import {
  DONE,
  FAILED,
  START,
  REMOVE_TERM_DONE,
  REMOVE_TERM_FAILED,
  REMOVE_TERM_START,
  UPLOAD_FORM_DATA_FILE,
  FETCH_TERMS_TYPES,
  CREATE_TERMS_TYPE,
  UPDATE_TERMS_TYPE,
  DELETE_TERMS_TYPE,
  FETCH_TERMS_VERSIONS,
  CREATE_TERMS_VERSION,
  UPDATE_TERMS_VERSION,
  FETCH_PENDING_TERMS,
  ACCEPT_TERMS,
  FETCH_TERMS_STATUS,
  FETCH_MY_TERMS_OVERVIEW,
} from "../../constants";
import { getAxiosInstance } from "../common";

export const UPDATE_MY_ORGANIZATION = "UPDATE_MY_ORGANIZATION";
export const UPLOAD_TERM_ORGANIZATION = "UPLOAD_TERM_ORGANIZATION";
export const FETCH_TERMS_ORGANIZATION = "FETCH_TERMS_ORGANIZATION";

export const updateMyOrganization = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_MY_ORGANIZATION + START });
  try {
    const result = await getAxiosInstance().put(`/api/organizations`, payload);
    dispatch({ type: UPDATE_MY_ORGANIZATION + DONE, payload: result.data });

    return result;
  } catch (error) {
    dispatch({ type: UPDATE_MY_ORGANIZATION + FAILED, error });
    return error.response;
  }
};

export const uploadOrganizationTerm = (payload) => async (dispatch) => {
  dispatch({ type: UPLOAD_TERM_ORGANIZATION + START });
  try {
    const { termFile, ...properties } = payload;

    const termData = new FormData();
    termData.append("file", termFile);
    termData.append(
      "properties",
      new Blob([JSON.stringify(properties)], {
        type: "application/json",
      })
    );

    const result = await getAxiosInstance().post(
      `/api/organizations/terms`,
      termData
    );
    dispatch({ type: UPLOAD_TERM_ORGANIZATION + DONE, payload: result.data });

    return result.data;
  } catch (payload) {
    dispatch({ type: UPLOAD_TERM_ORGANIZATION + FAILED, payload });
    return false;
  }
};

export const fetchOrganizationTerms = (termId) => async (dispatch) => {
  dispatch({ type: FETCH_TERMS_ORGANIZATION + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/organizations/${termId}/terms`
    );
    dispatch({ type: FETCH_TERMS_ORGANIZATION + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: FETCH_TERMS_ORGANIZATION + FAILED, payload });
    return false;
  }
};

export const removeTerm = (termId) => async (dispatch) => {
  dispatch(removeTermStart());
  try {
    const result = await getAxiosInstance().delete(
      `api/organizations/terms/${termId}`
    );

    dispatch(removeTermDone(result));
    return true;
  } catch (e) {
    dispatch(removeTermFailed(e));
    return false;
  }
};

export const removeTermStart = (payload) => ({
  type: REMOVE_TERM_START,
  payload,
});
export const removeTermDone = (payload) => ({
  type: REMOVE_TERM_DONE,
  payload: payload.data,
});
export const removeTermFailed = (payload) => ({
  type: REMOVE_TERM_FAILED,
  payload,
});

export const uploadFormDataFile = ({ file }) => async (dispatch) => {
  dispatch({ type: UPLOAD_FORM_DATA_FILE + START });
  try {
    const formData = new FormData();
    formData.append("file", file);

    const result = await getAxiosInstance().post(
      `/api/form_data/upload_file`,
      formData
    );
    dispatch({ type: UPLOAD_FORM_DATA_FILE + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: UPLOAD_FORM_DATA_FILE + FAILED, e });
    throw e;
  }
};

// --- Terms Types Management ---

export const fetchTermsTypes = () => async (dispatch) => {
  dispatch({ type: FETCH_TERMS_TYPES + START });
  try {
    const result = await getAxiosInstance().get("/api/organizations/terms-types");
    dispatch({ type: FETCH_TERMS_TYPES + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: FETCH_TERMS_TYPES + FAILED, error });
    return false;
  }
};

export const createTermsType = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_TERMS_TYPE + START });
  try {
    const result = await getAxiosInstance().post("/api/organizations/terms-types", payload);
    dispatch({ type: CREATE_TERMS_TYPE + DONE, payload: result.data });
    return { ok: true, data: result.data };
  } catch (error) {
    dispatch({ type: CREATE_TERMS_TYPE + FAILED, error });
    return {
      ok: false,
      code: error?.response?.data?.message,
    };
  }
};

export const updateTermsType = (id, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_TERMS_TYPE + START });
  try {
    const result = await getAxiosInstance().put(`/api/organizations/terms-types/${id}`, payload);
    dispatch({ type: UPDATE_TERMS_TYPE + DONE, payload: result.data });
    return { ok: true, data: result.data };
  } catch (error) {
    dispatch({ type: UPDATE_TERMS_TYPE + FAILED, error });
    return {
      ok: false,
      code: error?.response?.data?.message,
    };
  }
};

export const deleteTermsType = (id) => async (dispatch) => {
  dispatch({ type: DELETE_TERMS_TYPE + START });
  try {
    await getAxiosInstance().delete(`/api/organizations/terms-types/${id}`);
    dispatch({ type: DELETE_TERMS_TYPE + DONE, payload: id });
    return { ok: true };
  } catch (error) {
    dispatch({ type: DELETE_TERMS_TYPE + FAILED, error });
    return {
      ok: false,
      message: error?.response?.data?.message || "Nie udalo sie usunac typu regulaminu",
    };
  }
};

// --- Terms Versions Management ---

export const fetchTermsVersions = (typeId) => async (dispatch) => {
  dispatch({ type: FETCH_TERMS_VERSIONS + START });
  try {
    const result = await getAxiosInstance().get(`/api/organizations/terms-types/${typeId}/versions`);
    dispatch({ type: FETCH_TERMS_VERSIONS + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: FETCH_TERMS_VERSIONS + FAILED, error });
    return false;
  }
};

export const createTermsVersion = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_TERMS_VERSION + START });
  try {
    const { file, ...properties } = payload;

    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }
    formData.append(
      "properties",
      new Blob([JSON.stringify(properties)], { type: "application/json" })
    );

    const result = await getAxiosInstance().post("/api/organizations/terms-versions", formData);
    dispatch({ type: CREATE_TERMS_VERSION + DONE, payload: result.data });
    return { ok: true, data: result.data };
  } catch (error) {
    dispatch({ type: CREATE_TERMS_VERSION + FAILED, error });
    return {
      ok: false,
      code: error?.response?.data?.message,
    };
  }
};

export const updateTermsVersion = (id, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_TERMS_VERSION + START });
  try {
    const result = await getAxiosInstance().put(`/api/organizations/terms-versions/${id}`, payload);
    dispatch({ type: UPDATE_TERMS_VERSION + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: UPDATE_TERMS_VERSION + FAILED, error });
    return false;
  }
};

export const fetchTermsVersionRemovalImpact = (id) => async () => {
  try {
    const result = await getAxiosInstance().get(
      `/api/organizations/terms-versions/${id}/removal-impact`
    );
    return { ok: true, data: result.data };
  } catch (error) {
    return {
      ok: false,
      message: error?.response?.data?.message || "Nie udalo sie pobrac informacji o wycofaniu",
    };
  }
};

export const withdrawTermsVersion = (id, payload) => async (dispatch) => {
  try {
    const result = await getAxiosInstance().post(
      `/api/organizations/terms-versions/${id}/withdraw`,
      payload
    );
    return { ok: true, data: result.data };
  } catch (error) {
    return {
      ok: false,
      message: error?.response?.data?.message || "Nie udalo sie wycofac wersji regulaminu",
    };
  }
};

// --- Terms Acceptance (User) ---

export const fetchPendingTerms = () => async (dispatch) => {
  dispatch({ type: FETCH_PENDING_TERMS + START });
  try {
    const result = await getAxiosInstance().get("/api/terms/pending");
    dispatch({ type: FETCH_PENDING_TERMS + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: FETCH_PENDING_TERMS + FAILED, error });
    return false;
  }
};

export const acceptTerms = (termsVersionId) => async (dispatch) => {
  dispatch({ type: ACCEPT_TERMS + START });
  try {
    const result = await getAxiosInstance().post("/api/terms/accept", { termsVersionId });
    dispatch({ type: ACCEPT_TERMS + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: ACCEPT_TERMS + FAILED, error });
    return false;
  }
};

export const fetchTermsStatus = () => async (dispatch) => {
  dispatch({ type: FETCH_TERMS_STATUS + START });
  try {
    const result = await getAxiosInstance().get("/api/terms/status");
    dispatch({ type: FETCH_TERMS_STATUS + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: FETCH_TERMS_STATUS + FAILED, error });
    return false;
  }
};

export const fetchMyTermsOverview = () => async (dispatch) => {
  dispatch({ type: FETCH_MY_TERMS_OVERVIEW + START });
  try {
    const result = await getAxiosInstance().get("/api/terms/my-overview");
    dispatch({ type: FETCH_MY_TERMS_OVERVIEW + DONE, payload: result.data });
    return result.data;
  } catch (error) {
    dispatch({ type: FETCH_MY_TERMS_OVERVIEW + FAILED, error });
    return false;
  }
};
